import React from 'react'
import { utils, actions, selectors } from 'griddle-react'
/** Do not use recompose in other components */
import compose from 'recompose/compose'
import { createSelector } from 'reselect'
import withHandlers from 'recompose/withHandlers'
import styles from './Settings.css'

const connect = utils.connect

const columnChooser =
    compose(
      connect(
        (state) => ({
          columns: createSelector(
            selectors.sortedColumnPropertiesSelector,
            colMap => {
              const columns = colMap.valueSeq().toJS();
              return columns.filter(c => !c.isMetadata);
            }
          )(state),
        }),
        {
          toggleColumn: actions.toggleColumn
        }
      ),
      withHandlers({
        onToggle: ({toggleColumn}) => event => {
          toggleColumn(event.target.name)
        }
      })
    )(({ columns, onToggle }) => {
    return (
      <div className={styles.columnChooser}>
        <div className={styles.columnChooserTitle}>
          Show columns:
        </div>
        { Object.keys(columns).map(c =>
          <label key={columns[c].id} className={styles.columnItem}>
            <input
              type="checkbox"
              name={columns[c].id}
              defaultChecked={columns[c].visible !== false}
              onChange={onToggle}
            />
            {columns[c].title || columns[c].id}
          </label>
        )}
      </div>
    )});

  // const SimpleColumnChooserPlugin = {
  //   components:{
  //     SettingsComponents: {
  //       columnChooser,
  //     },
  //   },
  // };

export default columnChooser



// WEBPACK FOOTER //
// ../src/components/Table/components/ColumnChooser.js